import '../assets/NcAppSettingsSection-qU4SUZvh.css';
import { n as normalizeComponent } from "../chunks/_plugin-vue2_normalizer-D637Qkok.mjs";
const _sfc_main = {
  name: "NcAppSettingsSection",
  inject: ["registerSection", "unregisterSection"],
  props: {
    name: {
      type: String,
      required: true
    },
    id: {
      type: String,
      required: true,
      validator(id) {
        return /^[a-z0-9\-_]+$/.test(id);
      }
    }
  },
  computed: {
    // generate an id for each settingssection based on the name without whitespaces
    htmlId() {
      return "settings-section_" + this.id;
    }
  },
  // Reactive changes for section navigation
  watch: {
    id(newId, oldId) {
      var _a;
      this.unregisterSection(oldId);
      this.registerSection(newId, this.name, (_a = this.$slots) == null ? void 0 : _a.icon);
    },
    name(newName) {
      var _a;
      this.unregisterSection(this.id);
      this.registerSection(this.id, newName, (_a = this.$slots) == null ? void 0 : _a.icon);
    }
  },
  mounted() {
    var _a;
    this.registerSection(this.id, this.name, (_a = this.$slots) == null ? void 0 : _a.icon);
  },
  beforeDestroy() {
    this.unregisterSection(this.id);
  }
};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("section", { staticClass: "app-settings-section", attrs: { "id": _vm.htmlId, "aria-labelledby": "".concat(_vm.htmlId, "--label") } }, [_c("h3", { staticClass: "app-settings-section__name", attrs: { "id": "".concat(_vm.htmlId, "--label") } }, [_vm._v(" " + _vm._s(_vm.name) + " ")]), _vm._t("default"), _vm._e()], 2);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "e970c9f7",
  null,
  null
);
const NcAppSettingsSection = __component__.exports;
export {
  NcAppSettingsSection as default
};
